<!--  -->
<template>
  <div class=''>
    <div class="topBar">
      <div class="maxWidth">
        <div @click="$router.push({name: 'index'})" class="canClick">
          <img src="@/assets/haituan.png" class="topLogo" alt="">
          <div>嗨团商家入驻（二类医疗器械类目）</div>
        </div>
        <div>
          <el-input v-if="$route.name === 'index'" placeholder="关键字搜索" suffix-icon="el-icon-search" v-model="keywords" size="small"></el-input>
          <div>
            <el-dropdown>
              <div class="rightMsg canClick">
                <span class="nickname">个人中心</span>
                <img src="@/assets/haituan.png" width="30" height="30" alt="">
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="$router.push('/')">首 页</el-dropdown-item>
                <el-dropdown-item @click.native="$router.push('/user')">个人信息</el-dropdown-item>
                <el-dropdown-item @click.native="isDialog = true">修改密码</el-dropdown-item>
                <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="isDialog" title="修改密码" width="450px" :modal-append-to-body="false" :close-on-click-modal="false">
      <el-form
        :model="pwdData"
        label-position="right"
        label-width="100px"
        ref="pwd"
        :rules="pwdRules"
      >
        <el-form-item label="旧密码" prop="old">
          <el-input v-model="pwdData.old"  placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input type="password" v-model="pwdData.password"  placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input type="password" v-model="pwdData.repassword"  placeholder="请确认密码"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="isDialog = false">取 消</el-button>
        <el-button type="primary" @click="changePwd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    const repassword = (rule, value, callback) => {
      if (value !== this.pwdData.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      isDialog: false,
      pwdData: {},

      pwdRules: {
        old: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" }
        ],
        repassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: repassword, trigger: "change" }
        ]
      }
    }
  },
  computed: {
    keywords: {
      get() {
        return this.$store.state.keywords
      },
      set(keywords) {
        this.$store.commit('CHANGE_KEYWORDS', keywords)
      }
    }
  },
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  methods: {
    logout() {
      this.$store.commit('LOG_OUT')
      this.$router.push({name: 'login'})
    },
    changePwd() {
      this.$refs.pwd.validate(valid => {
        if (!valid) return false;
        this.$http.post("/api/WebUser/ModifyUserPwd",{
          oldPassword: this.pwdData.old,
          newPassword: this.pwdData.password
        }).then(() => {
          this.isDialog = false;
          this.$router.push("/login");
          this.$message.success('修改成功, 请重新登录');
          this.LOG_OUT();
        }).catch(() => {});
      });
    }
  },
}
</script>
<style lang='scss' scoped>

.topBar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 54px;
  background: #39A4DC;
  color: #fff;
  .topLogo {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    font-size: 18px;
    > div {
      display: flex;
      align-items: center;
    }
  }
  .rightMsg {
    display: flex;
    align-items: center;
    margin-left: 40px;
    > span {
      color: #fff;
    }
    .nickname {
      white-space: nowrap;
    }
    img {
      border-radius: 10%;
      width: 30px;
      height: 30px;
      margin-left: 10px;
    }
  }
}
</style>